import { Crown, MessageCircle } from "lucide-react";

const PLANS = [
  { key: "1m", name: "1 Bulan", price: 99000, note: "akses sinyal penuh 30 hari" },
  { key: "3m", name: "3 Bulan", price: 249000, note: "hemat Rp48.000" },
  { key: "12m", name: "1 Tahun", price: 999000, note: "hemat Rp189.000" },
];

const fmtRp = (n) => `Rp${Number(n).toLocaleString("id-ID")}`;

export const PlansPanel = ({ user }) => {
  const exp = user?.access_expires;
  const active = exp && new Date(exp).getTime() > Date.now();
  const status = active
    ? user?.tier === "PREMIUM"
      ? `PREMIUM aktif s/d ${exp.slice(0, 10)}`
      : `TRIAL aktif s/d ${exp.slice(0, 10)}`
    : "BELUM AKTIF — hubungi admin";

  return (
    <div className="border border-white/10 bg-[#0d1219] p-4" data-testid="plans-panel">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="flex items-center gap-2 font-mono text-[9px] uppercase tracking-[0.25em] text-mute-dim">
          <Crown size={12} className="text-warn" /> Paket Berbayar
        </p>
        <span className={`border px-2 py-0.5 font-mono text-[9px] font-bold ${active ? "border-buy/40 bg-buy/10 text-buy" : "border-sell/40 bg-sell/10 text-sell"}`}
          data-testid="plan-status">
          {status}
        </span>
      </div>

      <div className="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-3">
        {PLANS.map((p) => (
          <div key={p.key} className="border border-white/10 bg-ink px-4 py-3 text-center" data-testid={`plan-card-${p.key}`}>
            <p className="font-mono text-[10px] uppercase tracking-widest text-mute">{p.name}</p>
            <p className="mt-1.5 font-display text-xl font-black text-white">{fmtRp(p.price)}</p>
            <p className="mt-1 font-mono text-[9px] text-mute-dim">{p.note}</p>
          </div>
        ))}
      </div>

      <button onClick={() => window.dispatchEvent(new Event("open-support"))} data-testid="plan-contact-admin"
        className="mt-4 flex h-10 w-full items-center justify-center gap-2 border border-buy bg-buy/10 font-mono text-xs font-bold uppercase tracking-wider text-buy transition-colors hover:bg-buy hover:text-ink">
        <MessageCircle size={14} /> Hubungi Admin untuk Pembayaran
      </button>
      <p className="mt-2 font-mono text-[9px] leading-relaxed text-mute-dim">
        &gt; pembayaran manual — admin mengirim QRIS/rekening lewat chat Support, Anda cukup balas dengan bukti transfer.
      </p>
    </div>
  );
};
